import {useEffect, useState} from "react";
import {couponClockDelay, couponLocalNow} from "./coupon-lifecycle";

export default function useCouponClock(coupons) {
    const [now, setNow] = useState(couponLocalNow);
    useEffect(() => { setNow(couponLocalNow()); }, [coupons]);
    useEffect(() => {
        const update = () => setNow(couponLocalNow());
        // Recheck at the next boundary, after waking the tab, and at least once a minute for clock changes.
        const timer = setTimeout(update, couponClockDelay(coupons || [], couponLocalNow()));
        window.addEventListener("focus", update);
        document.addEventListener("visibilitychange", update);
        return () => {
            clearTimeout(timer);
            window.removeEventListener("focus", update);
            document.removeEventListener("visibilitychange", update);
        };
    }, [coupons, now]);
    return now;
}
